export const basePath = '/api/web';